import script from "./SlideDesignPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlideDesignPanel.vue?vue&type=script&lang=ts&setup=true"

import "./SlideDesignPanel.vue?vue&type=style&index=0&id=9a96acfa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a96acfa"]])

export default __exports__